/* DiversityBar — samenvattingsbalk voor de Diversity-lens (Sprint 4b · #15).
 * Geëxtraheerd uit pages/dashboard/Matches.jsx (refactor).
 */
import React from "react";

export function DiversityBar({ label, data }) {
    if (!data) return null;
    const entries = Object.entries(data);
    // sort by pct desc for clean bar
    entries.sort((a, b) => (b[1]?.pct || 0) - (a[1]?.pct || 0));
    const palette = ["#0891b2", "#a855f7", "#f59e0b", "#22c55e", "#ef4444", "#94a3b8"];
    return (
        <div>
            <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-[var(--jr-text-3)] mb-1">{label}</div>
            <div className="w-full h-2 rounded-full overflow-hidden bg-white/5 flex">
                {entries.map(([k, v], i) => (
                    <div key={k} style={{ width: `${v.pct}%`, backgroundColor: palette[i % palette.length] }} title={`${k}: ${v.count} (${v.pct}%)`}/>
                ))}
            </div>
            <div className="mt-1 flex flex-wrap gap-x-2 gap-y-0.5 text-[10px] text-[var(--jr-text-2)]">
                {entries.map(([k, v], i) => (
                    <span key={k} className="whitespace-nowrap">
                        <span className="inline-block w-2 h-2 rounded-full align-middle mr-1" style={{ backgroundColor: palette[i % palette.length] }}/>
                        {k} · {v.pct}%
                    </span>
                ))}
            </div>
        </div>
    );
}
